import React, { useState, useEffect } from 'react'
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, ContentState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

function EditorBox({onBlur, onKeyChange, initialContent, className="", toolbarOptions=null}) {
    const [state,setState] = useState({
        editorState: EditorState.createEmpty(),
        html: ""
    })

    useEffect(() => {
        if(state.html !== initialContent){

            const blocksFromHtml = htmlToDraft(initialContent ?? "");
            const { contentBlocks, entityMap } = blocksFromHtml;
            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
            setState(prevState => ({
                ...prevState,
                editorState: EditorState.createWithContent(contentState),
                html: initialContent
            }))
        }
    }, [initialContent])

    useEffect(() => {
        if(state.html !== "" && state.html !== initialContent){
            onKeyChange(state.html)
        }
    }, [state.html])



    const onEditorStateChange = async(editorState) => {
        let html = draftToHtml(convertToRaw(editorState.getCurrentContent()))
        if(!editorState.getCurrentContent().hasText()){
            html = ""
        }
        
        await setState(prevState => ({
            ...prevState,
            editorState,
            html
        }))

    }

    const { editorState, html }= state

    return <Editor
        {...(toolbarOptions !== null ? ({toolbar: {options: toolbarOptions}}) : {})}
        editorState={editorState}
        toolbarClassName="toolbarClassName"
        wrapperClassName={"wrapperClassName "+className}
        editorClassName={"wysiwyg"}
        onEditorStateChange={onEditorStateChange}
        onBlur={() => onBlur(html)}
     />
}

export default EditorBox